export const LOCAL_STORAGE_KEY_ACCESS_TOKEN = 'LOCAL_STORAGE_KEY_ACCESS_TOKEN';
export const LOCAL_STORAGE_KEY_LOCALE = 'LOCAL_STORAGE_KEY_LOCALE';
export const LOCAL_STORAGE_KEY_LOGIN_ATTEMPTS_EXPIRED = 'LOCAL_STORAGE_KEY_LOGIN_ATTEMPTS_EXPIRED';
export const LOCAL_STORAGE_KEY_LOGIN_THIRD_PARTY_ATTEMPTS_EXPIRED = 'LOCAL_STORAGE_KEY_LOGIN_THIRD_PARTY_ATTEMPTS_EXPIRED';
